import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, total, limit, onPage }) {
  const pages = Math.max(1, Math.ceil(total / limit));
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-white/10">
      <span className="text-xs text-slate-500">Page {page} of {pages} · {total} total</span>
      <div className="flex gap-2">
        <Button data-testid="page-prev" variant="outline" size="sm" disabled={page <= 1} onClick={() => onPage(page - 1)} className="border-white/10 bg-white/5 text-white">
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <Button data-testid="page-next" variant="outline" size="sm" disabled={page >= pages} onClick={() => onPage(page + 1)} className="border-white/10 bg-white/5 text-white">
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-white">{title}</h1>
        {subtitle && <p className="text-slate-400 text-sm mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
